function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9842 0H2.42818C1.10601 0 0.0341797 1.07183 0.0341797 2.394V13.566C0.0341797 14.8882 1.10601 15.96 2.42818 15.96H19.9842C21.3064 15.96 22.3782 14.8882 22.3782 13.566V2.394C22.3782 1.07183 21.3064 0 19.9842 0ZM20.7822 9.24562L15.7604 4.22382C15.4488 3.91228 14.9436 3.91228 14.632 4.22382L8.0142 10.8416L5.38636 8.21377C5.07477 7.90222 4.5696 7.90222 4.258 8.21377L1.63017 10.8416V2.394C1.63017 1.95326 1.98744 1.59599 2.42818 1.59599H19.9842C20.425 1.59599 20.7822 1.95326 20.7822 2.394V9.24562H20.7822Z",
  fill: "#464849"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.21615 7.9799C8.53832 7.9799 9.61015 6.90807 9.61015 5.5859C9.61015 4.26373 8.53832 3.19189 7.21615 3.19189C5.89398 3.19189 4.82214 4.26373 4.82214 5.5859C4.82214 6.90807 5.89398 7.9799 7.21615 7.9799Z",
  fill: "#464849"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9542 7.97998L28.7383 12.768L25.5702 7.97998H31.9542Z",
  fill: "#464849"
});

function SvgImageupload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageupload);
export default __webpack_public_path__ + "static/media/imageupload.0de26e56.svg";
export { ForwardRef as ReactComponent };